import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-descargar-productos',
  templateUrl: './descargar-productos.component.html',
  styleUrls: ['./descargar-productos.component.css'],
})
export class DescargarProductosComponent implements OnInit {

  safeUrl: SafeResourceUrl;
  
    constructor(
      private authService: AuthService,
      private sanitizer: DomSanitizer
    ) { }
  
    ngOnInit() {
      const acccessToken = this.authService.getToken();

    const iframeUrl = `${environment.ADMIN_URL}dashboard/productos/listado-productos-categorias?token=${acccessToken}`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/descargar-productos/descargar-productos.component.ts